import { render } from "./kalio-program-goal-form.vue?vue&type=template&id=229d30b6"
import script from "./kalio-program-goal-form.vue?vue&type=script&lang=js"
export * from "./kalio-program-goal-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__